import type { IntlShape } from 'react-intl';

import { CertificatePaymentModeEnum } from '@share/common-types';

function roundCurrency2(value: number): number {
  return Math.round(value * 100) / 100;
}

export function formatUsdDisplay(amount: number): string {
  return `$${roundCurrency2(amount).toFixed(2)}`;
}

export function getPaymentTypeDisplayLabel(
  intl: IntlShape,
  paymentMode: CertificatePaymentModeEnum | undefined,
  instalmentPlanMonths: number,
): string {
  switch (paymentMode) {
    case CertificatePaymentModeEnum.PayInFullSplit:
      return intl.formatMessage({ id: 'certificates.success.paymentType.fullSplit' });
    case CertificatePaymentModeEnum.Instalments:
      return intl.formatMessage(
        { id: 'certificates.success.paymentType.instalments' },
        { months: instalmentPlanMonths },
      );
    case CertificatePaymentModeEnum.InstalmentsSplitDownPayment:
      return intl.formatMessage(
        { id: 'certificates.success.paymentType.instalmentsSplit' },
        { months: instalmentPlanMonths },
      );
    case CertificatePaymentModeEnum.PayInFull:
    default:
      return intl.formatMessage({ id: 'certificates.success.paymentType.paidFull' });
  }
}

export const formatExpiryDate = (validityMonths: number): string => {
  const date = new Date();
  date.setMonth(date.getMonth() + validityMonths);
  return date.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
};
